import { z } from 'zod';
import { type TranslateRawFunc } from '#common/i18n/edit-mode.tsx';
import { emailSchema } from '#common/utils/user-validation';

export function anonymousRegistrationSchema(t: TranslateRawFunc) {
    return z.object({
        email: emailSchema(t),
        marketingConsent: z.literal('on', { message: t('audio-generation:consent-required') }).transform(() => true)
    });
}

export function verifyCodeSchema(t: TranslateRawFunc) {
    return z.object({
        email: z.string().email(),
        code: z.string().length(6, { message: t('audio-generation:verification-code-length') })
    });
}
